import { AddressType } from '../../AddressType';

const defaultProps: (keyof AddressType)[] = [
  'street1',
  'street2',
  'city',
  'state',
  'country',
  'code',
];

export function addressFormatter(
  address: Partial<AddressType> | null | undefined,
  props: (keyof AddressType)[] = defaultProps
): string {
  if (!address) {
    return '';
  }

  return props
    .filter(prop => prop !== 'name') // name is now deprecated
    .map(prop => address[prop])
    .filter(part => !!part)
    .join(', ');
}
